(function(){
  'use strict';
  var root=document.querySelector('[data-emx-pulse]');
  if(!root||root.dataset.pulseReady==='true')return;
  root.dataset.pulseReady='true';

  var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var sections=Array.prototype.slice.call(document.querySelectorAll('#MainContent > .shopify-section'));

  if(reduce||!('IntersectionObserver' in window)){
    sections.forEach(function(section){section.classList.add('emx-section-visible');});
    return;
  }

  document.documentElement.classList.add('emx-motion-enabled');

  var observer=new IntersectionObserver(function(entries){
    entries.forEach(function(entry){
      if(entry.isIntersecting){
        entry.target.classList.add('emx-section-visible');
        observer.unobserve(entry.target);
      }
    });
  },{threshold:.08,rootMargin:'0px 0px -6% 0px'});

  sections.forEach(function(section,index){
    if(index===0){section.classList.add('emx-section-visible');return;}
    section.classList.add('emx-site-reveal');
    observer.observe(section);
  });
})();
